export class UnifiedRestoreEntityRelationships {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "memberOf",
            "baseName": "memberOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "roles",
            "baseName": "roles",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "licenses",
            "baseName": "licenses",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreEntityRelationships.attributeTypeMap;
    }
    constructor() {
    }
}
